import React, { memo, useEffect } from "react";
import WebView from "react-native-webview";
import { Platform, View } from "react-native";
const BajajKycDigioModal = ({ targetUrl, callBackAction, triggerAction }) => {
    useEffect(() => {
        console.warn("CONSOLE FOR OPTIONS KYC BAJAJ");
    }, []);
    const onNavigationStateChanged = (event) => {
        const url = event?.url;
        const doContainOnCloseHtml = url && url.includes('voltmoney.in/close-on-open.html');
        if (doContainOnCloseHtml) {
            callBackAction &&
                triggerAction(callBackAction);
        }
    };
    // @ts-ignore
    return (React.createElement(View, { style: { width: '100%', height: '100%' } },
        React.createElement(WebView, { style: {
                width: '100%',
                height: 650,
                marginBottom: 20
            }, source: { uri: `${targetUrl}` }, javaScriptEnabled: true, domStorageEnabled: true, onNavigationStateChange: (event) => onNavigationStateChanged(event), originWhitelist: ['*'], automaticallyAdjustContentInsets: false, useWebKit: true, allowsInlineMediaPlayback: true, scalesPageToFit: Platform.OS === 'android', scrollEnabled: true, mediaPlaybackRequiresUserAction: false, javaScriptEnabledAndroid: true, showsHorizontalScrollIndicator: false, nestedScrollEnabled: Platform.OS !== "web" })));
};
export default memo(BajajKycDigioModal);
export { BajajKycDigioModal };
